export function choiceId(id: string, value: string, index: number) {
  return [id, index, value.replace(/\s+/g, '-')].join('-');
}
